import React from 'react';
import {Route, Routes as Router} from 'react-router-dom';

import Main from "../containers/Main";

import Dashboard from "../views/Dashboard/Dashboard";
import NotFound from "../views/NotFound/NotFound";
import Login from "../views/Login/Login";
import RequireAuth from "./RequireAuth";
import Products from "../views/Product/Products";
import CreateProduct from "../views/Product/CreateProduct";
import Teams from "../views/Team/Teams";
import CreateTeam from "../views/Team/CreateTeam";
import Categories from "../views/Category/Categories";
import CreateCategory from "../views/Category/CreateCategory";
import OrderProgress from "../views/Order/OrderProgress";
import Orders from "../views/Order/Orders";

export default function AppRouter() {
    return (
        <Router>
            <Route path={'/login'} element={<Login/>}/>
            {/*<Route path={'/recuperar-senha'} element={<RememberPassword/>}/>*/}
            {/*<Route path={'/alterar-senha'} element={<ChangePassword/>}/>*/}
            <Route
                element={(
                    <RequireAuth>
                        <Main/>
                    </RequireAuth>
                )}>
                <Route path={'/'} element={<Dashboard/>}/>

                <Route path={'/products'} element={<Products/>}/>
                <Route path={'/product/create'} element={<CreateProduct/>}/>
                <Route path={'/product/create/:id'} element={<CreateProduct/>}/>

                <Route path={'/teams'} element={<Teams/>}/>
                <Route path={'/team/create'} element={<CreateTeam/>}/>
                <Route path={'/team/create/:id'} element={<CreateTeam/>}/>

                <Route path={'/categories'} element={<Categories/>}/>
                <Route path={'/category/create'} element={<CreateCategory/>}/>
                <Route path={'/category/create/:id'} element={<CreateCategory/>}/>

                <Route path={'/orders'} element={<Orders/>}/>
                {/*<Route path={'/order/:id'} element={<Categories/>}/>*/}
                <Route path={'/order/progress/:id'} element={<OrderProgress/>}/>

            </Route>
            <Route path="*" element={<NotFound/>}/>
        </Router>
    );
};
